/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ErrorResponse } from '../models/error-response';
import { ErrorRequest } from '../models/error-request';
@Injectable({
  providedIn: 'root',
})
class ErrorsService extends __BaseService {
static readonly postPath = '/errors';
static readonly forceServerErrorPath = '/errors/force';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param error undefined
   * @return Success
   */
  private postResponse(error?: ErrorRequest): __Observable<__StrictHttpResponse<ErrorResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = error;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/errors`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ErrorResponse>;
      })
    );
  }

  /**
   * @param error undefined
   * @return Success
   */
  post(error?: ErrorRequest): __Observable<ErrorResponse> {
    return this.postResponse(error).pipe(
      __map(_r => _r.body as ErrorResponse)
    );
  }

  /**
   * @param statusCode undefined
   */
  private forceServerErrorResponse(statusCode?: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (statusCode != null) __params = __params.set('statusCode', statusCode.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/errors/force`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param statusCode undefined
   */
  forceServerError(statusCode?: number): __Observable<null> {
    return this.forceServerErrorResponse(statusCode).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module ErrorsService {
}

export { ErrorsService }
